import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import { getOnboardingRedirectPath, MERCHANT_ONBOARDING_FIRST_PATH } from '../../utils/onboardingRedirect';

function RootRedirect() {
  const UsersProfile = useSelector((state) => state?.auth?.user);
  const MeProfile = useSelector((state) => state?.auth?.me);
  const isLoggedIn = useSelector((state) => state?.auth?.login);

  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  // Profile still loading - show spinner to avoid blank flash
  if (!UsersProfile) {
    return (
      <div
        className="spin"
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}
      >
        <Spin size="large" />
      </div>
    );
  }

  const role = UsersProfile?.role;
  const onboardingFromUser = UsersProfile?.onboarding_steps;
  const onboardingFromMe = MeProfile?.onboarding_steps;
  const onboarding = onboardingFromMe || onboardingFromUser || null;
  const currentStep = onboarding?.current_step ?? UsersProfile?.current_step;
  if (role === 'super_admin') {
    return <Navigate to="/merchants" replace />;
  }

  if (role === 'merchant') {
    if (!onboarding || onboarding?.all_completed === true || currentStep === 6) {
      return <Navigate to="/profile" replace />;
    }
    const path = getOnboardingRedirectPath(onboarding);
    return <Navigate to={path || MERCHANT_ONBOARDING_FIRST_PATH} replace />;
  }

  if (role === 'staff') {
    return <Navigate to="/staff-profile" replace />;
  }

  if (role === 'sales_agent') {
    return <Navigate to="/sales-agent-profile" replace />;
  }

  // Fallback for other roles
  return <Navigate to="/merchants" replace />;
}

export default RootRedirect;
